// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__WNXqR","label":"styles_label__csHNC","caption":"styles_caption__7aHFf","description":"styles_description__QQ__c","content":"styles_content__3O_9i"};